import { ReactNode } from 'react';

import { useSiteSettings } from '../../utils';

export interface EcomOnlyProps {
  children: ReactNode;
}

export const EcomOnly = ({ children }: EcomOnlyProps) => {
  const { ecom } = useSiteSettings();
  if (!ecom?.ecomEnabled) {
    return null;
  }
  return <>{children}</>;
};
